import { create } from "zustand";

interface IdefaultValues {
    id: number | string,
    onClick: () => void
}

const defaultValues = {
    id: "",
    onClick: () => { }
}

interface IuseDeleteModel {
    onOpenDeletePopup: ({ id }: IdefaultValues) => void,
    onCloseDeletePopup: () => void
    initialValues: IdefaultValues
}

export const useDeleteModel = create<IuseDeleteModel>((set) => ({
    initialValues: defaultValues,
    onOpenDeletePopup: ({ id, onClick }: IdefaultValues) => set({
        initialValues: { id, onClick }
    }),
    onCloseDeletePopup: () => set({
        initialValues: defaultValues
    }),
}))
